import * as Yup from "yup";

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const RegisterValidation = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email format")
    .required("email is required"),
    profileId: Yup.string()
    .trim()
    .required("Profile ID is required"),
  name: Yup.string()
    .min(2, "name atleast of 2 characters")
    .max(120, "name cannot greater than 120 characters")
    .trim()
    .required("name is required"),
  password: Yup.string()
    .required("Password is required")
    .matches(
      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/,
      "Password must contain at least 8 characters, including at least one uppercase letter, one lowercase letter, and one number"
    ),
  confirmPassword: Yup.string()
    .required("Confirm password is required")
    .oneOf([Yup.ref("password")], "Passwords must match"),
});

export const LoginValidation = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email format")
    .required("email is required"),
  password: Yup.string()
    .trim()
    .min(4, "password atleast of 4 characters")
    .max(10, "password cannot greater than 30 characters")
    .required("Password is required"),
});

export const changePasswordValidation = Yup.object().shape({
  currentPassword: Yup.string()
    .trim()
    .min(4, "Password atleast of 4 characters")
    .max(30, "Password cannot greater than 30 characters")
    .required("Password is required"),
  newPassword: Yup.string()
    .required("New Password is required")
    .trim()
    .min(4, "New Password atleast of 4 characters")
    .max(30, "New password cannot greater than 30 characters"),
  confirmPassword: Yup.string()
    .required("Confirm password is required")
    .oneOf([Yup.ref("newPassword")], "Passwords must match"),
});

export const changePasswordWithoutCurrentValidation = Yup.object().shape({
  newPassword: Yup.string()
    .required("New Password is required")
    .trim()
    .min(4, "New Password atleast of 4 characters")
    .max(30, "New password cannot greater than 30 characters"),
  confirmPassword: Yup.string()
    .required("Confirm password is required")
    .oneOf([Yup.ref("newPassword")], "Passwords must match"),
});
